import { RESET_STATE } from 'store/global/actions';

import { MARKET_TO_MARKET_ACTION_TYPE } from '../actions';

const initialState = {};

const marketToMarketReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MARKET_TO_MARKET_ACTION_TYPE.GET_MARKET_TO_MARKET:
      return payload || state;

    case MARKET_TO_MARKET_ACTION_TYPE.UPDATE_MARKET_TO_MARKET:
      return { ...state, ...payload };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default marketToMarketReducer;
